<ul class="navbar-nav">
    <!-- Company Select Switch -->
    <li
        class="nav-item nav-company-name text-white bold"
        *ngIf="
            navigationState.user &&
            navigationState.companyName &&
            !(responsiveService.smBelow | async)
        "
    >
        <span class="nav-text company-name-container" href="javascript:void(0)">
            <lsq-truncate [value]="navigationState.companyName" maxLength="35"></lsq-truncate>
            <lsq-icon-popover
                *ngIf="isClientTerminated"
                [height]="12"
                [style.height]="'12px'"
                [style.margin-left]="'0.5rem'"
                [style.margin-top]="'-0.1rem'"
                [width]="12"
                [icon]="alertIcon"
                text="Your account is inactive. If you would like to reactivate please call 1-800-474-7606"
            >
            </lsq-icon-popover>
        </span>
        <ng-container>
            <ng-container
                *ngIf="
                    !!(identityService.relationshipName$ | async) &&
                    (identityService.relationshipName$ | async)?.length
                "
            >
                <span class="nav-text relationship-name-container">
                    <lsq-truncate
                        [value]="identityService.relationshipName$ | async"
                        maxLength="35"
                    ></lsq-truncate>
                </span>
            </ng-container>
        </ng-container>
    </li>

    <!-- Global Search Toggle -->
    <li
        *ngIf="
            (claimService.isOn(claim.ViewReports) | async) &&
            navigationState.user &&
            navigationState.user.currentCompany
        "
        class="nav-item icon-nav-item"
        [ngClass]="{ active: globalSearchService.isExpanded$ | async }"
    >
        <a
            *ngIf="!(globalSearchService.isExpanded$ | async)"
            class="nav-link icon-nav-link search-nav-link"
            href="javascript:void(0)"
            (click)="handleGlobalSearchToggle(true)"
        >
            <lsq-icon [type]="icons.FaMagnifyingGlassSolid"></lsq-icon>
            <span class="sr-only">global search</span>
        </a>
        <a
            *ngIf="globalSearchService.isExpanded$ | async"
            class="nav-link icon-nav-link search-nav-link"
            href="javascript:void(0)"
            (click)="handleGlobalSearchToggle(false)"
        >
            <lsq-icon [type]="icons.CloseSmall"></lsq-icon>
            <span class="sr-only">exit global search</span>
        </a>
    </li>

    <!-- Notifications Toggle and Window -->
    <li
        *ngIf="
            (canHaveNotifications$ | async) &&
            navigationState.user &&
            navigationState.user.currentCompany
        "
        class="nav-item icon-nav-item"
        id="notification-nav-item-mobile"
    >
        <a
            id="notification-{{ classNames.DropdownToggle }}"
            class="nav-link icon-nav-link"
            href="javascript:void(0)"
            role="button"
            aria-haspopup="true"
            [attr.aria-label]="
                (notificationsService.notificationCount$ | async) > 0
                    ? 'expand ' +
                      (notificationsService.notificationCount$ | async) +
                      ' notifications'
                    : 'expand notifications (none at this time)'
            "
            [attr.aria-expanded]="notificationsService.isExpanded$ | async"
            (click)="toggleNotificationWindow()"
        >
            <div
                class="notification-badge"
                *ngIf="notificationsService.notificationCount$ | async"
            ></div>
            <span
                id="bell-{{ classNames.DropdownToggle }}-icon"
                class="{{ classNames.DropdownToggle }}-icon"
            >
                <lsq-icon [type]="icons.Bell"></lsq-icon>
            </span>
        </a>
        <notifications></notifications>
    </li>
</ul>
